import { createContext, useContext, useState } from 'react';

import { getPlacesQuery } from './queries/ZipCodeQuery';

import type { ReactFCWithChildren } from '@widget/types/ReactFCWithChildren';

export type ZipCodeLocationType = {
  id?: string;
  name?: string;
};

export type ZipCodeLocationDataContextType = {
  zipCodeLocationData: ZipCodeLocationType | null;
  fetchZipcodeLocationData: (zipCode: string) => void;
};

const ZipCodeLocationDataContext = createContext<ZipCodeLocationDataContextType | null>(null);

export const ZipCodeLocationDataProvider: ReactFCWithChildren<any> = ({ children }) => {
  const [zipCodeLocationData, setZipCodeLocationData] = useState<ZipCodeLocationType | null>(null);

  const fetchZipcodeLocationData = async (zipCode: string) => {
    const places = await getPlacesQuery(zipCode, ['de', 'at']);
    if (places?.length > 0) {
      const data = places[0];
      setZipCodeLocationData({
        id: data?.id.toString(),
        name: data?.displayName,
      });
    }
  };

  return (
    <ZipCodeLocationDataContext.Provider
      value={{
        zipCodeLocationData,
        fetchZipcodeLocationData,
      }}
    >
      {children}
    </ZipCodeLocationDataContext.Provider>
  );
};

export const useZipCodeLocation = (): ZipCodeLocationDataContextType => {
  const zipCodeLocationData = useContext(ZipCodeLocationDataContext);

  if (zipCodeLocationData === null) {
    throw new Error(
      'The useZipCodeLocation hook must be used within the ZipCodeLocationDataProvider',
    );
  }

  return zipCodeLocationData;
};
